import { render, staticRenderFns } from "./case-status-config.vue?vue&type=template&id=05168a66&scoped=true"
import script from "./case-status-config.vue?vue&type=script&lang=ts"
export * from "./case-status-config.vue?vue&type=script&lang=ts"
import style0 from "./case-status-config.vue?vue&type=style&index=0&id=05168a66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05168a66",
  null
  
)

export default component.exports